import { ProductFragment } from '../../../../types/__generated__';
import usePageQuery, { buildQuery } from '../../usePageQuery';
import Fragment from './Product.gql';

const ProductQuery = buildQuery(Fragment);

export function useProduct() {
  const { data } = usePageQuery<ProductFragment>(ProductQuery);

  return {
    name: data?.product?.name ?? undefined,
    features: data?.product?.features ?? {},
    ownerType: data?.product?.ownerType ?? undefined,
    allowedPointsOfView: data?.product?.allowedPointsOfView ?? [],
    allowedDonationTypes: data?.product?.allowedDonationTypes ?? [],
    allowedDonationMethods: data?.product?.allowedDonationMethods ?? [],
  };
}
